import { render } from "./appFacilitaModal.vue?vue&type=template&id=1fc191be&scoped=true"
import script from "./appFacilitaModal.vue?vue&type=script&lang=js"
export * from "./appFacilitaModal.vue?vue&type=script&lang=js"

import "./appFacilitaModal.vue?vue&type=style&index=0&id=1fc191be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc191be"]])

export default __exports__